import { MarketingNavTypes, NavLink, NavSlice } from '@dtx-company/true-common/src/types/appContent'
import { TPrismicNavHeader, TPrismicNavLink } from './v2/Nav.types'
import { asText } from '@prismicio/client'
import { marketingNavigationMock } from '../../../containers/nav/top/v2/__mock__/MarketingNavigationMock'
import { parseInternalLinks } from '@dtx-company/inter-app/src/utils/links'

export const fetchMarketingNavData = (): MarketingNavTypes => {
  return (marketingNavigationMock.data.body as Record<string, any>).reduce(
    (
      acc: MarketingNavTypes,
      {
        slice_type,
        items,
        primary
      }: {
        slice_type: 'desktop' | 'mobile'
        primary: TPrismicNavHeader
        items: TPrismicNavLink[]
      }
    ) => {
      const parsedSlice: NavSlice = {
        items: items.map(
          ({
            fullwidth,
            link_title,
            link_subtext,
            dropdown_link,
            isexternal
          }: TPrismicNavLink): NavLink => ({
            fullWidth: fullwidth,
            label: asText(link_title),
            label_subtext: asText(link_subtext),
            link: dropdown_link.url ? parseInternalLinks(dropdown_link.url) : '',
            isExternal: isexternal
          })
        ),
        columns: primary.columns,
        label: asText(primary.header),
        link: primary.header_link.url ? parseInternalLinks(primary.header_link.url) : '',
        isDense: primary.isdense,
        isExternal: primary.isexternal
      }
      if (acc[slice_type]) {
        acc[slice_type].push(parsedSlice)
      } else {
        acc[slice_type] = [parsedSlice]
      }
      return acc
    },
    {}
  )
}
